import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../../providers/AuthProvider';
import api from '../../../utils/api';
import { toast } from 'react-toastify';
import PlansSelection from '../../../ScreensCompanies/Profile/components/PlansSelection/PlansSelection';
import PaymentCheckoutModal from '../../../ScreensCompanies/Profile/PaymentCheckoutModal';
import './UpgradeModal.css';

const UpgradeModal = ({ open, onClose, title = null }) => {
  const { user, updateUser } = useContext(AuthContext);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPriceForModal, setSelectedPriceForModal] = useState(null);
  const [selectedPlanForModal, setSelectedPlanForModal] = useState(null);
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (open) {
      fetchPlans();
    }
  }, [open]);

  const fetchPlans = async () => {
    try {
      const { data } = await api.get("/companies/payment_plans");
      if (data?.data) {
        const plansList = data.data.map(item => ({
          id: item.id,
          ...item.attributes
        }));
        setPlans(plansList);
      }
    } catch (error) {
      console.error("Erro ao buscar planos:", error);
    }
  };

  const handlePriceSelect = async (priceId) => {
    try {
      let selectedPrice = null;
      let selectedPlan = null;

      for (const plan of plans) {
        const price = plan.prices?.find(p => p.id === priceId);
        if (price) {
          selectedPrice = price;
          selectedPlan = plan;
          break;
        }
      }

      if (!selectedPrice || !selectedPlan) {
        toast.error("Erro ao selecionar o plano. Tente novamente.");
        return;
      }

      const { data } = await api.get("/companies/has_payment_method");
      const hasCard = data?.data?.attributes?.hasPaymentMethod || false;

      setHasPaymentMethod(hasCard);
      setSelectedPriceForModal(selectedPrice);
      setSelectedPlanForModal(selectedPlan);
      setShowPaymentModal(true);
    } catch (error) {
      console.error("Erro ao verificar método de pagamento:", error);
      toast.error("Erro ao processar solicitação. Tente novamente.");
    }
  };

  const handleModalSuccess = async () => {
    setShowPaymentModal(false);
    setSelectedPlanForModal(null);
    setSelectedPriceForModal(null);

    try {
      const { data } = await api.get(`/companies/companies/${user.id}`);

      if (data && updateUser) {
        await updateUser(data);
      }

      toast.success("Plano atualizado! Você já pode usar todas as funcionalidades.");

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Erro ao atualizar dados do usuário:", error);
      onClose();
    }
  };

  const handleModalCancel = () => {
    setShowPaymentModal(false);
    setSelectedPlanForModal(null);
    setSelectedPriceForModal(null);
  };

  if (!open) return null;

  // Default title if none provided
  const modalTitle = title || 'Seu plano atual não inclui este recurso';

  return (
    <>
      <div className="upgradeModalOverlay" onClick={onClose}>
        <div className="upgradeModalContentWide" onClick={(e) => e.stopPropagation()}>
          <button className="upgradeModalClose" onClick={onClose}>×</button>

          <div className="upgradeModalHeader">
            <h3 className="upgradeModalTitle">{modalTitle}</h3>
          </div>
          <div className="upgradeModalBody">
            <p className="upgradeModalSubtext">
              Você está usando o plano <strong>{user?.subscription?.paymentPlan?.name}</strong>. Para acessar esta funcionalidade,
              faça um upgrade no plano contratado
            </p>
          </div>

          <PlansSelection
            onPriceSelect={handlePriceSelect}
            plans={plans}
            showCurrentPlan={true}
            compactMode={true}
          />
        </div>
      </div>

      {showPaymentModal && selectedPlanForModal && selectedPriceForModal && (
        <PaymentCheckoutModal
          selectedPrice={selectedPriceForModal}
          selectedPlan={selectedPlanForModal}
          plans={plans}
          hasPaymentMethod={hasPaymentMethod}
          onSuccess={handleModalSuccess}
          onCancel={handleModalCancel}
        />
      )}
    </>
  );
};

export default UpgradeModal;
